module.exports = __webpack_public_path__ + "img/DOC_document_icon@2x.16afe761.png";